(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("FrameSelection", [], factory);
	else if(typeof exports === 'object')
		exports["FrameSelection"] = factory();
	else
		root["FrameSelection"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 3);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = addStylesClient;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__listToStyles__ = __webpack_require__(7);
/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
  Modified by Evan You @yyx990803
*/



var hasDocument = typeof document !== 'undefined'

if (typeof DEBUG !== 'undefined' && DEBUG) {
  if (!hasDocument) {
    throw new Error(
    'vue-style-loader cannot be used in a non-browser environment. ' +
    "Use { target: 'node' } in your Webpack config to indicate a server-rendering environment."
  ) }
}

/*
type StyleObject = {
  id: number;
  parts: Array<StyleObjectPart>
}

type StyleObjectPart = {
  css: string;
  media: string;
  sourceMap: ?string
}
*/

var stylesInDom = {/*
  [id: number]: {
    id: number,
    refs: number,
    parts: Array<(obj?: StyleObjectPart) => void>
  }
*/}

var head = hasDocument && (document.head || document.getElementsByTagName('head')[0])
var singletonElement = null
var singletonCounter = 0
var isProduction = false
var noop = function () {}
var options = null
var ssrIdKey = 'data-vue-ssr-id'

// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
// tags it will allow on a page
var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase())

function addStylesClient (parentId, list, _isProduction, _options) {
  isProduction = _isProduction

  options = _options || {}

  var styles = Object(__WEBPACK_IMPORTED_MODULE_0__listToStyles__["a" /* default */])(parentId, list)
  addStylesToDom(styles)

  return function update (newList) {
    var mayRemove = []
    for (var i = 0; i < styles.length; i++) {
      var item = styles[i]
      var domStyle = stylesInDom[item.id]
      domStyle.refs--
      mayRemove.push(domStyle)
    }
    if (newList) {
      styles = Object(__WEBPACK_IMPORTED_MODULE_0__listToStyles__["a" /* default */])(parentId, newList)
      addStylesToDom(styles)
    } else {
      styles = []
    }
    for (var i = 0; i < mayRemove.length; i++) {
      var domStyle = mayRemove[i]
      if (domStyle.refs === 0) {
        for (var j = 0; j < domStyle.parts.length; j++) {
          domStyle.parts[j]()
        }
        delete stylesInDom[domStyle.id]
      }
    }
  }
}

function addStylesToDom (styles /* Array<StyleObject> */) {
  for (var i = 0; i < styles.length; i++) {
    var item = styles[i]
    var domStyle = stylesInDom[item.id]
    if (domStyle) {
      domStyle.refs++
      for (var j = 0; j < domStyle.parts.length; j++) {
        domStyle.parts[j](item.parts[j])
      }
      for (; j < item.parts.length; j++) {
        domStyle.parts.push(addStyle(item.parts[j]))
      }
      if (domStyle.parts.length > item.parts.length) {
        domStyle.parts.length = item.parts.length
      }
    } else {
      var parts = []
      for (var j = 0; j < item.parts.length; j++) {
        parts.push(addStyle(item.parts[j]))
      }
      stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts }
    }
  }
}

function createStyleElement () {
  var styleElement = document.createElement('style')
  styleElement.type = 'text/css'
  head.appendChild(styleElement)
  return styleElement
}

function addStyle (obj /* StyleObjectPart */) {
  var update, remove
  var styleElement = document.querySelector('style[' + ssrIdKey + '~="' + obj.id + '"]')

  if (styleElement) {
    if (isProduction) {
      // has SSR styles and in production mode.
      // simply do nothing.
      return noop
    } else {
      // has SSR styles but in dev mode.
      // for some reason Chrome can't handle source map in server-rendered
      // style tags - source maps in <style> only works if the style tag is
      // created and inserted dynamically. So we remove the server rendered
      // styles and inject new ones.
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  if (isOldIE) {
    // use singleton mode for IE9.
    var styleIndex = singletonCounter++
    styleElement = singletonElement || (singletonElement = createStyleElement())
    update = applyToSingletonTag.bind(null, styleElement, styleIndex, false)
    remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true)
  } else {
    // use multi-style-tag mode in all other cases
    styleElement = createStyleElement()
    update = applyToTag.bind(null, styleElement)
    remove = function () {
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  update(obj)

  return function updateStyle (newObj /* StyleObjectPart */) {
    if (newObj) {
      if (newObj.css === obj.css &&
          newObj.media === obj.media &&
          newObj.sourceMap === obj.sourceMap) {
        return
      }
      update(obj = newObj)
    } else {
      remove()
    }
  }
}

var replaceText = (function () {
  var textStore = []

  return function (index, replacement) {
    textStore[index] = replacement
    return textStore.filter(Boolean).join('\n')
  }
})()

function applyToSingletonTag (styleElement, index, remove, obj) {
  var css = remove ? '' : obj.css

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = replaceText(index, css)
  } else {
    var cssNode = document.createTextNode(css)
    var childNodes = styleElement.childNodes
    if (childNodes[index]) styleElement.removeChild(childNodes[index])
    if (childNodes.length) {
      styleElement.insertBefore(cssNode, childNodes[index])
    } else {
      styleElement.appendChild(cssNode)
    }
  }
}

function applyToTag (styleElement, obj) {
  var css = obj.css
  var media = obj.media
  var sourceMap = obj.sourceMap

  if (media) {
    styleElement.setAttribute('media', media)
  }
  if (options.ssrId) {
    styleElement.setAttribute(ssrIdKey, obj.id)
  }

  if (sourceMap) {
    // https://developer.chrome.com/devtools/docs/javascript-debugging
    // this makes source maps inside style tags work properly in Chrome
    css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */'
    // http://stackoverflow.com/a/26603875
    css += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + ' */'
  }

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild)
    }
    styleElement.appendChild(document.createTextNode(css))
  }
}


/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'FrameSelection',
    props: {
        // Y轴数据
        AxisX: {
            type: Array,
            default: function _default() {
                return [];
            }
        },
        // X轴数据
        AxisY: {
            type: Array,
            default: function _default() {
                return [];
            }
        },
        // 设置默认 已选择的格子
        defaultSelectCellBox: {
            type: Array
        },
        // 设置默认 可选中的盒子
        usableBox: {
            type: null,
            default: 'all'
        },
        // 小方格宽度
        cellWidth: {
            type: Number,
            default: 17
        },
        // 小方格高度
        cellHeight: {
            type: Number,
            default: 17
        },
        // 滚动宽度
        maxWidth: {
            type: Number,
            default: 200
        },
        // 滚动高度
        maxHeight: {
            type: Number,
            default: 200
        },
        // 提示信息
        title: {
            type: String,
            default: ''
        },
        // 是否显示清空按钮
        clearBtn: {
            type: Boolean,
            default: false
        }
    },
    data: function data() {
        return {
            // 结果数组
            resArr: []
        };
    },

    methods: {
        // 添加格子
        addCell: function addCell() {
            var AxisX = this.AxisX; // 时效
            var AxisY = this.AxisY; // 高度
            var usableBox = this.usableBox; // 可选值
            var width = this.cellWidth; // 格子宽度
            var height = this.cellHeight; // 格子高度

            var cellBox = this.$refs.cellBox; // 格子盒子
            var heightList = this.$refs.heightList; // Y轴盒子
            var prescriptionList = this.$refs.prescriptionList; // X轴盒子


            // 初始化格子盒子
            for (var i = 0; i < AxisY.length; i++) {
                for (var j = 0; j < AxisX.length; j++) {
                    var li = document.createElement('li');
                    li.setAttribute('data', AxisX[j] + ',' + AxisY[i]);
                    li.setAttribute('title', AxisX[j] + ',' + AxisY[i]);
                    li.classList.add('cellItemBox');
                    if (usableBox !== "all") li.classList.add("disable");
                    li.style.cssText = 'height:' + height + 'px;width:' + width + 'px;';

                    cellBox.appendChild(li);
                }
            }
            // 初始化X轴盒子
            for (var _i = 0; _i < AxisX.length; _i++) {

                var span = document.createElement('span');
                span.innerText = AxisX[_i];
                span.style.cssText = 'height:' + height + 'px;width:' + width + 'px;display:inline-block;text-align:center;';

                prescriptionList.appendChild(span);
            }
            // 初始化Y轴盒子
            for (var _i2 = 0; _i2 < AxisY.length; _i2++) {
                var _span = document.createElement('span');
                _span.innerText = AxisY[_i2];
                _span.style.cssText = 'height:' + height + 'px;line-height:' + height + 'px;';

                heightList.appendChild(_span);
            }

            // 监听各类事件监听
            this.addBoxSelect();

            // 更改盒子大小
            this.setBoxSize();
        },

        //更改盒子大小
        setBoxSize: function setBoxSize() {
            var box = this.$refs.cellBox;
            var prescriptionList = this.$refs.prescriptionList;
            var bigBox = this.$refs.bigBox;
            // 获得默认参数
            var cellWidth = this.cellWidth;
            var cellHeight = this.cellHeight;
            var maxWidth = this.maxWidth;
            var maxHeight = this.maxHeight;

            var width = this.AxisX.length * cellWidth + 2 + 'px';
            var height = this.AxisY.length * cellHeight + 'px';

            var bigHeight = maxHeight - 20 + 'px';
            // 滚动盒子
            bigBox.style.cssText = 'height:' + bigHeight + ';width:' + maxWidth + 'px;';
            // 格子盒子
            box.style.cssText = 'height:' + height + ';width:' + width + ';';
            // X轴盒子
            prescriptionList.style.cssText = 'width:' + width + ';height:' + cellHeight + ';';
        },

        // 添加格子的事件监听
        addBoxSelect: function addBoxSelect() {
            var _this = this;

            var that = this;
            this.$nextTick(function () {
                var ele = _this.$refs.cellBox;
                var reactArea = {
                    startX: 0,
                    startY: 0,
                    endX: 0,
                    endY: 0
                    // 判定为点击还是框选
                };var firstTime = void 0,
                    lastTime = void 0,
                    isMouseDown = false;
                //将元素定位改为relative
                ele.style.position = 'relative';

                ele.addEventListener('mousedown', function (e) {
                    // 存储开始的坐标点
                    reactArea.startX = e.layerX;
                    reactArea.startY = e.layerY;
                    // 记录开始状态
                    isMouseDown = true;

                    // 鼠标按下
                    that.$emit('mousedownMethods', e);

                    firstTime = new Date().getTime();
                    ele.addEventListener('mousemove', moveHander);
                });

                ele.addEventListener('mouseup', function (e) {
                    lastTime = new Date().getTime();
                    isMouseDown = false;

                    // 鼠标抬起
                    that.$emit('mouseupMethods', e);

                    // 判断书否为点击状态
                    if (lastTime - firstTime < 200) {
                        ele.removeEventListener('mousemove', moveHander);
                        that.selectBox(e);
                    } else {
                        that.handleSelect();
                        ele.removeEventListener('mousemove', moveHander);
                    }
                });
                // 鼠标移出 选中离开之前的默认选中项
                ele.addEventListener('mouseleave', function (e) {
                    // 鼠标离开区域
                    that.$emit('mouseleaveMethods', e);

                    // 判断是否为down 状态下移出的
                    if (isMouseDown) {
                        that.handleSelect();
                        ele.removeEventListener('mousemove', moveHander);
                    }
                    isMouseDown = false;
                });
                // 移动处理函数
                function moveHander(e) {
                    var X = e.layerX;
                    var Y = e.layerY;
                    // if (X % 5 == 0 || Y % 5 == 0) {
                    var allActive = [];
                    reactArea.endX = X;
                    reactArea.endY = Y;
                    var leftValue = 0;
                    var topValue = 0;
                    var widthValue = Math.abs(reactArea.startX - reactArea.endX);
                    var heightValue = Math.abs(reactArea.startY - reactArea.endY);

                    if (reactArea.startX > reactArea.endX) {
                        leftValue = reactArea.endX;
                    } else {
                        leftValue = reactArea.startX;
                    }
                    if (reactArea.startY > reactArea.endY) {
                        topValue = reactArea.endY;
                    } else {
                        topValue = reactArea.startY;
                    }

                    var children = ele.querySelectorAll('.cellItemBox');

                    for (var i = 0; i < children.length; i++) {
                        // 每个li元素的宽高
                        var childrenHeight = children[i].getBoundingClientRect().height;
                        var childrenWidth = children[i].getBoundingClientRect().width;
                        //每个li元素的位置
                        var offsetLeft = children[i].offsetLeft;
                        var offsetTop = children[i].offsetTop;
                        //每个li元素的宽高
                        var endPositionH = childrenHeight + offsetTop;
                        var endPositionW = childrenWidth + offsetLeft;

                        //选择区域在元素体内 跳过
                        var requireBoxIn = offsetTop < topValue && offsetLeft < leftValue && offsetTop + childrenHeight > topValue + heightValue && offsetLeft + childrenWidth > leftValue + widthValue;
                        if (requireBoxIn) return;

                        //五个条件满足一个就可以判断被选择
                        //一是右下角在选择区域内
                        var require1 = endPositionH > topValue && endPositionW > leftValue && endPositionH < topValue + heightValue && endPositionW < leftValue + widthValue;
                        //二是左上角在选择区域内
                        var require2 = offsetTop > topValue && offsetLeft > leftValue && offsetTop < topValue + heightValue && offsetLeft < leftValue + widthValue;
                        //三是右上角在选择区域内
                        var require3 = offsetTop > topValue && offsetLeft + childrenWidth > leftValue && offsetTop < topValue + heightValue && offsetLeft + childrenWidth < leftValue + widthValue;
                        //四是左下角在选择区域内
                        var require4 = offsetTop + childrenHeight > topValue && offsetLeft > leftValue && offsetTop + childrenHeight < topValue + heightValue && offsetLeft < leftValue + widthValue;

                        // 六 两个方向 “中” 选中
                        // 上下
                        var require5 = topValue < offsetTop && topValue + heightValue > endPositionH && leftValue > offsetLeft && leftValue + widthValue < endPositionW;
                        // 左右
                        var require6 = leftValue < offsetLeft && leftValue + widthValue > endPositionW && topValue > offsetTop && topValue + heightValue < endPositionH;

                        // 七 四个角的 “凹凸” 选中
                        // 上
                        var require7 = topValue + heightValue > offsetTop && topValue + heightValue < endPositionH && offsetLeft < leftValue && endPositionW > leftValue + widthValue;
                        // 下
                        var require8 = topValue > offsetTop && leftValue > offsetLeft && topValue < endPositionH && leftValue + widthValue < endPositionW;
                        // 左
                        var require9 = topValue > offsetTop && topValue + heightValue < endPositionH && leftValue + widthValue > offsetLeft && leftValue + widthValue < endPositionW;
                        // 右
                        var require10 = topValue > offsetTop && topValue + heightValue < endPositionH && leftValue > offsetLeft && leftValue < endPositionW;

                        if (require1 || require2 || require3 || require4 || require5 || require6 || require7 || require8 || require9 || require10) {

                            if (children[i].classList.contains("disable")) return;

                            children[i].classList.add('selectedBox');
                        } else {
                            children[i].classList.remove('selectedBox');
                        }
                        // }
                    }
                }
            });
        },

        // 框选 抛出数据
        handleSelect: function handleSelect() {
            this.resArr = [];
            var arr = [];
            var arrChild = this.$refs.cellBox.childNodes;

            // let arrChild = document.querySelectorAll('.cellItemBox');

            for (var i = 0; i < arrChild.length; i++) {
                if (arrChild[i].classList.contains('selectedBox')) {
                    arrChild[i].classList.remove('selectedBox');
                    arrChild[i].classList.add('active');
                }
                if (arrChild[i].classList.contains('active')) {
                    arr.push(arrChild[i].getAttribute('data').split(','));
                }
            }

            this.resArr = arr;
            this.$emit("selectCell", arr);
        },

        // 点击 抛出数据
        selectBox: function selectBox(e) {

            // 如果点击是空div 和空text 就跳过
            if (e.target.nodeName === "DIV") return;

            var flg = true;
            var resArr = JSON.parse(JSON.stringify(this.resArr));
            var box = e.target;
            if (!box.getAttribute("data")) return;
            var val = box.getAttribute("data").split(",");
            // 判断如果 有disable类名 则禁止点击
            var disable = box.classList.contains("disable");
            if (disable) return;

            if (resArr.length !== 0) {
                for (var i = 0; i < resArr.length; i++) {
                    if (resArr[i].join() == val.join()) {
                        resArr.splice(i, 1);
                        box.classList.remove("selectedBox");
                        box.classList.remove("active");
                        flg = false;
                        break;
                    }
                }
            }

            if (flg) {
                resArr.push(val);
                box.classList.add("active");
            }
            this.resArr = resArr;
            this.$emit("selectCell", resArr);
        },


        // 设置默认 可选中的盒子
        defaultBox: function defaultBox(value) {
            var _this2 = this;

            var deCell = value;
            this.$nextTick(function () {
                // 所有的数据格子
                var allcell = _this2.$refs.cellBox.childNodes;

                for (var i = 0; i < allcell.length; i++) {
                    if (allcell[i].nodeName == "#text") continue;
                    if (deCell === "all") {
                        allcell[i].classList.remove("disable");
                        continue;
                    };
                    if (deCell.length == 0) {
                        allcell[i].classList.contains('active') ? '' : allcell[i].classList.add("disable");
                        continue;
                    }
                    for (var j = 0; j < deCell.length; j++) {
                        if (allcell[i].attributes["data"].nodeValue == deCell[j]) {
                            allcell[i].classList.remove("disable");
                        }
                    }
                }
            });
        },

        // 设置默认 已选择的格子
        defaultActive: function defaultActive(value) {
            var _this3 = this;

            // 传来默认显示的格子数据
            var deCell = value;
            this.$nextTick(function () {
                // 所有的数据格子
                var allcell = _this3.$refs.cellBox.childNodes;

                for (var i = 0; i < allcell.length; i++) {
                    if (allcell[i].nodeName == "#text") continue;
                    allcell[i].classList.remove("active");
                    for (var j = 0; j < deCell.length; j++) {
                        if (allcell[i].attributes["data"].nodeValue == deCell[j].join()) {
                            allcell[i].classList.remove("disable");
                            allcell[i].classList.add("active");
                        }
                    }
                }
            });

            this.resArr = deCell;
        }
    },
    mounted: function mounted() {
        // 新建格子
        this.addCell();
    },

    watch: {
        // 如果有默认数据 进行绘制
        defaultSelectCellBox: function defaultSelectCellBox(value) {
            this.defaultActive(value);
        },

        // 添加可选中状态
        usableBox: function usableBox(value) {
            this.defaultBox(value);
        }
    }
});

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__frameSelection_vue__ = __webpack_require__(4);
// sumFunction 插件对应组件的名字


// Vue.js 的插件应当有一个公开方法 install 。第一个参数是 Vue 构造器，第二个参数是一个可选的选项对象
// 参考：https://cn.vuejs.org/v2/guide/plugins.html#%E5%BC%80%E5%8F%91%E6%8F%92%E4%BB%B6
// 此处注意，组件需要添加name属性，代表注册的组件名称，也可以修改成其他的
__WEBPACK_IMPORTED_MODULE_0__frameSelection_vue__["a" /* default */].install = function (Vue) {
  return Vue.component(__WEBPACK_IMPORTED_MODULE_0__frameSelection_vue__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__frameSelection_vue__["a" /* default */]);
}; //注册组件

/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__frameSelection_vue__["a" /* default */]);

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_frameSelection_vue__ = __webpack_require__(2);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_97b2cf56_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_frameSelection_vue__ = __webpack_require__(11);
function injectStyle (ssrContext) {
  __webpack_require__(5)
  __webpack_require__(8)
}
var normalizeComponent = __webpack_require__(10)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-97b2cf56"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_frameSelection_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_97b2cf56_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_frameSelection_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(6);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(1).default
var update = add("2a599278", content, true, {});

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, ".cellBox[data-v-97b2cf56]{display:inline-block;flex-wrap:wrap;flex-direction:column;font-size:12px}.cellBox .cellBoxTop[data-v-97b2cf56]{display:flex}.cellBox .cellBoxTop .cellBoxTitle[data-v-97b2cf56]{height:20px;flex:1;font-size:14px;text-align:left;padding-left:15px}.cellBox .cellBoxTop .clearBtn[data-v-97b2cf56]{width:35px;cursor:pointer;border:1px solid #ccc;border-radius:5px;color:#606266}.cellBox .cellBoxTop .clearBtn[data-v-97b2cf56]:hover{color:#3a8ee6;border-color:#3a8ee6}.cellBox .cellBoxContetnAuto[data-v-97b2cf56]{position:relative;overflow:scroll}.cellBox .cellBoxContetnAuto .cellBoxContetnLeft[data-v-97b2cf56]{position:absolute;top:0;left:0;width:50px;display:flex;flex-wrap:wrap;flex-direction:column}.cellBox .cellBoxContetnAuto .cellBoxContetnLeft>span[data-v-97b2cf56]{width:100%}.cellBox .cellBoxContetnAuto .cellBoxContetnItem[data-v-97b2cf56]{width:189px;display:flex;flex-wrap:wrap;top:0;left:50px;border:1px solid #000;border-bottom:none;border-right:none}.cellBox .cellBoxContetnAuto .prescriptionList[data-v-97b2cf56]{margin-left:50px}", ""]);

// exports


/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = listToStyles;
/**
 * Translates the list format produced by css-loader into something
 * easier to manipulate.
 */
function listToStyles (parentId, list) {
  var styles = []
  var newStyles = {}
  for (var i = 0; i < list.length; i++) {
    var item = list[i]
    var id = item[0]
    var css = item[1]
    var media = item[2]
    var sourceMap = item[3]
    var part = {
      id: parentId + ':' + i,
      css: css,
      media: media,
      sourceMap: sourceMap
    }
    if (!newStyles[id]) {
      styles.push(newStyles[id] = { id: id, parts: [part] })
    } else {
      newStyles[id].parts.push(part)
    }
  }
  return styles
}


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(9);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(1).default
var update = add("5038377c", content, true, {});

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, ".cellItemBox{border-right:1px solid #000;border-bottom:1px solid #000;box-sizing:border-box;cursor:pointer}.active{background-color:#588dc8;border:1px solid #fff;cursor:pointer}.disable{background-color:hsla(0,0%,80%,.5);cursor:no-drop}.selectedBox{background-color:#409eff;border:1px solid #fff;cursor:pointer}.scroll::-webkit-scrollbar{width:6px;height:6px}.scroll::-webkit-scrollbar,.scroll::-webkit-scrollbar-corner{background-color:transparent}.scroll::-webkit-scrollbar-track{border-radius:10px;background-color:transparent}.scroll::-webkit-scrollbar-thumb{border-radius:10px;box-shadow:inset 0 0 6px rgba(0,0,0,.3);background-color:#ccc}.cellBox{-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none;-khtml-user-select:none;user-select:none}.cellBox div,.cellBox li,.cellBox p,.cellBox span,.cellBox ul{box-sizing:border-box}.cellBox li,.cellBox ul{padding:0;margin:0;list-style:none}", ""]);

// exports


/***/ }),
/* 10 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file.
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate

    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cellBox"},[_c('div',{staticClass:"cellBoxTop"},[_c('div',{staticClass:"cellBoxTitle"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),(_vm.clearBtn)?_c('div',{staticClass:"clearBtn",on:{"click":function($event){_vm.$emit('clearAll'),_vm.defaultActive([])}}},[_vm._v("清空")]):_vm._e()]),_vm._v(" "),_c('div',{ref:"bigBox",staticClass:"cellBoxContetnAuto scroll"},[_c('div',{ref:"heightList",staticClass:"cellBoxContetnLeft"}),_vm._v(" "),_c('ul',{ref:"cellBox",staticClass:"cellBoxContetnItem"}),_vm._v(" "),_c('div',{ref:"prescriptionList",staticClass:"prescriptionList"})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// FrameSelection.js